import { render, staticRenderFns } from "./ztDropdownSubItem.vue?vue&type=template&id=485719c4"
import script from "./ztDropdownSubItem.vue?vue&type=script&lang=js"
export * from "./ztDropdownSubItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports